import * as React from 'react';
import cn from 'classnames/bind';
import classes from './index.module.scss.js';

const cx = cn.bind(classes);
const FormLabel = (props) => {
    const { children, disabled = false, hasError = false } = props;
    return (React.createElement("p", { className: `${cx({ label: true, disabled, hasError })} caption` }, children));
};

export { FormLabel };
//# sourceMappingURL=index.js.map
